import { ContasRecebimentoForm } from "../../../presentation/schemas/ContasReceber_lista/ContasReceber_recebimento";
import { IRecebimentoContasUseCase } from "../../../presentation/useCases/update/recebimento_contas_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * RecebimentoContasUseCase
 */

export class RecebimentoContasUseCase implements IRecebimentoContasUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async recebimentoContas(form: ContasRecebimentoForm): Promise<void> {
    await this.repository.recebimentoContas(form);

  }

}
